// Day 3 — urgent.

import type { EmailData } from "../../types";
import { longDate } from "../../format";
import { b, esc, p } from "../../layouts/chrome";
import { NO_PAYMENT, pricedEmailHtml } from "../../layouts/priced";
import { brand } from "../brand";

export const subject = ({ renewalDate }: EmailData) =>
  `Urgent: your ${brand.name} renewal on ${longDate(renewalDate)}`;

export const html = (data: EmailData) =>
  pricedEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    quotes: data.quotes ?? [],
    payment: data.payment ?? NO_PAYMENT,
    policyRef: data.policyRef,
    versionRef: data.versionRef,
    bodyHtml: p(
      `This is an urgent reminder from ${brand.name}. Your insurance policy for ${b(`'${esc(data.companyName)}' will expire on ${longDate(data.renewalDate)}`)}. This is one of your last opportunities to renew and avoid a break in cover. Your policy will ${b("not auto-renew — action is required.")}`,
    ),
  });
